export interface Review {
  id: string;
  movieId: string;
  movieTitle: string;
  title: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  cover: string;
  readingTime: number;
}

export const reviews: Review[] = [
  {
    id: 'review-silent',
    movieId: 'silent-confession',
    movieTitle: '沉默的告白',
    title: '当沉默成为共谋：一次关于良知的缓慢审判',
    excerpt: '《沉默的告白》最动人的地方，不在于它给出了答案，而在于它把问题交还给了观众。',
    content: '在一座看似平静的新英格兰小镇，体面是一种集体维持的表演。影片用大量静止的长镜头，把女主角格蕾丝的犹豫拍成了一种物理性的重量。她不是没有勇气，而是清楚地知道，说出真相会让所有人一起坠落。导演拒绝廉价的道德审判，让每个角色的立场都具备可理解的理由。看完之后你会明白，真正可怕的从来不是谎言本身，而是所有人默契地选择不说。',
    author: '编辑部 · 林深',
    date: '2026-09-28',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinematic%20still%20of%20an%20empty%20rainy%20new%20england%20street%20at%20dusk%20with%20warm%20lamplight%2C%20moody%20slate%20blue%20and%20amber%20tones%2C%20film%20grain%2C%20quiet%20melancholic%20depth%2C%20no%20text&width=800&height=500&seq=review-cover-01&orientation=landscape',
    readingTime: 8,
  },
  {
    id: 'review-testimony',
    movieId: 'testimony-long-night',
    movieTitle: '长夜的证词',
    title: '一个人的证人席：勇气的成本有多高',
    excerpt: '它没有把主角塑造成英雄，而是把一个普通人放在聚光灯下，逼他看着自己。',
    content: '长期以来，司法题材的电影习惯塑造孤胆英雄。但《长夜的证词》选择了一条更难的路：主角只是一个夜班保安，他胆小、犹豫、会计算利弊，和大多数人一样。正因如此，他在漫长几夜里的挣扎才格外真实。影片用近乎纪录片的手法记录他反复权衡的过程，让“作证”这个简单动作变成一场对勇气的严苛审判。导演想说的或许是——勇气从来不是天生的，它是一次次害怕之后仍然选择站出来的结果。',
    author: '编辑部 · 陈默',
    date: '2026-08-30',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinematic%20still%20of%20an%20empty%20courthouse%20hallway%20at%20night%20with%20cold%20light%20and%20one%20warm%20window%20glow%2C%20solemn%20tense%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=review-cover-02&orientation=landscape',
    readingTime: 10,
  },
  {
    id: 'review-boundary',
    movieId: 'beyond-the-line',
    movieTitle: '边界之外',
    title: '界线之内是人，界线之外也是',
    excerpt: '导演把宏大的议题收进一个家庭的选择里，让每一个观众都无法置身事外。',
    content: '《边界之外》最厉害的一点，是它从不高声说教。它只是安静地跟着一个普通家庭，看他们在收留一个陌生旅人之后，如何一点点被法律、舆论与良心三股力量撕扯。影片没有反派，每个人都在做自认为正确的事，而悲剧恰恰由此产生。收尾的处理尤其高明，导演没有给出判决，只留下一个长镜头，让观众带着问题走出影院。这是一部会让讨论延续到片尾字幕之后的电影。',
    author: '编辑部 · 苏晚',
    date: '2026-07-02',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinematic%20still%20of%20a%20vast%20desert%20dawn%20landscape%20with%20a%20distant%20fence%20line%2C%20deep%20indigo%20sky%20and%20warm%20orange%20horizon%2C%20epic%20restrained%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=review-cover-03&orientation=landscape',
    readingTime: 12,
  },
  {
    id: 'review-ash',
    movieId: 'ash-and-vow',
    movieTitle: '灰烬之约',
    title: '遗产之下：一个家族如何与记忆和解',
    excerpt: '家庭伦理片很容易滑向煽情，但《灰烬之约》保持了难得的冷静。',
    content: '当一位父亲离世，留下的不只是房子和存款，还有一整套无人愿意触碰的沉默。影片把冲突都放在餐桌与走廊这些日常空间里，让争吵显得真实而不戏剧化。三兄妹各自站在自己的立场上，都无比正确，又都无比疲惫。影片最重要的贡献，是它承认“原谅”并不是一个必选项——有时候，理解本身就是终点。这种不强行大团圆的克制，反而让结尾的安静拥有了极大的力量。',
    author: '编辑部 · 顾南',
    date: '2026-09-21',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinematic%20still%20of%20an%20old%20american%20farmhouse%20at%20sunset%20with%20warm%20golden%20dust%2C%20nostalgic%20melancholic%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=review-cover-04&orientation=landscape',
    readingTime: 9,
  },
  {
    id: 'review-coast',
    movieId: 'glass-coast',
    movieTitle: '玻璃海岸',
    title: '没有反派的悲剧：一部关于选择的社区寓言',
    excerpt: '记者不是圣人，工人也不是帮凶，所有人都在有限的选项里艰难求生。',
    content: '很少有社会议题片能像《玻璃海岸》这样克制。影片里的每一个人都在做自己认为正确的事，却共同造成了伤害。导演对灰色地带的尊重，让它超越了一般的社会议题片，成为一面照见现实困境的镜子。它不提供答案，只提供理解，而这种理解本身就已经足够珍贵。',
    author: '编辑部 · 林深',
    date: '2026-09-12',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinematic%20still%20of%20a%20stormy%20coastline%20with%20a%20small%20cliff%20factory%2C%20overcast%20grey%20sky%2C%20cold%20distant%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=review-cover-05&orientation=landscape',
    readingTime: 7,
  },
  {
    id: 'review-hothouse',
    movieId: 'hothouse',
    movieTitle: '温床',
    title: '当爱变成温室，谁先窒息',
    excerpt: '一部关于情感边界的锋利之作，把一段逐渐失衡的关系剖得清清楚楚。',
    content: '“我是为你好”这句话，可能是爱情里最有杀伤力的武器。《温床》用温室这个意象贯穿始终，把关心如何一步步变质为控制，拍得细腻又令人不安。女主角一次次说服自己“他只是在乎我”，观众却比她更早地看见了裂缝。影片没有简单地把谁定性为施害者，而是让两个人都成为这段关系的共谋，这种复杂性正是它值得反复观看的原因。',
    author: '编辑部 · 苏晚',
    date: '2026-07-18',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinematic%20still%20inside%20a%20hazy%20greenhouse%20with%20dense%20tropical%20plants%20and%20warm%20light%2C%20humid%20emerald%20and%20amber%20tones%2C%20intimate%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=500&seq=review-cover-06&orientation=landscape',
    readingTime: 6,
  },
];

export const getReviewByMovieId = (movieId: string): Review | undefined =>
  reviews.find((r) => r.movieId === movieId);